import type { TFunction } from "i18next";

import { notify } from "@components/atoms/notify";

/**
 * Copies the given text to the clipboard.
 * @param text The text to be copied to the clipboard.
 * @param t
 */
export const copyTextToClipboard = async (
  text: string,
  t: TFunction<"form">,
): Promise<void> => {
  try {
    await navigator.clipboard.writeText(text);
    notify.success({ text: t("copied_to_clipboard") });
  } catch {
    notify.error({ text: t("clipboard_error") });
  }
};
